import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.tooltip = window.bootstrap.Tooltip.getOrCreateInstance(this.element)

    if (!this.element.dataset.bsTrigger?.includes('click')) return

    this.hideOnOutsideClick = this.hideOnOutsideClick.bind(this)
    document.addEventListener('click', this.hideOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this.hideOnOutsideClick)
    this.tooltip?.dispose()
  }

  hideOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    if (event.target.closest('.tooltip')) return

    this.tooltip.hide()
  }
}
